<template>

  <div class="upload-file-box">
    <a-spin :spinning="loading">
      <a-upload
        name="upload"
        :headers="headers"
        :data="data"
        :before-upload="beforeUpload"
        :custom-request="customRequest"
        :transform-file="transformFile" 
        :multiple="true"
        :file-list="fileList"
        list-type="picture-card"
        :remove="remove"
        @preview="handlePreview"
        @change="handleChange"
        :disabled="!advertiser_id"
      >

        <div v-if="fileList.length < maxNum">
          <a-icon :type="loading ? 'loading' : 'upload'" />
          <div class="ant-upload-text">点击上传</div>
        </div>
      </a-upload>

      <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel" :title="previewImage.name">
        <img v-if="previewImage.file_type == 2" :src="previewImage.url" style="width: 80%" />
        
        <video  controls style="width: 100%" :src="previewImage.url" v-else/>

        <div v-if="previewImage.file && previewImage.file.status == 'error'" :style="{
            position: 'absolute',
            right: 0,
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e9e9e9',
            padding: '10px 16px',
            background: '#fff',
            textAlign: 'right',
            zIndex: 1,
        }">
        <a-button type="primary" @click="againUpload(previewImage.file)" :disabled="loading" :style="{ marginRight: '8px' }">
          重新上传
        </a-button>
      </div>
      </a-modal>
    </a-spin>

  </div>



 
</template>

<style lang="less" scoped>
@import 'JuliangUpload';
</style>

<script>
import JuliangUpload from './JuliangUpload'
export default JuliangUpload
</script>
